import { Injectable } from '@angular/core';

import { LativHttpClient } from '@service/lativ.interceptor';
import {
  Category,
  CategoryContent,
  GetCategoryContentRequest,
  GetCategoryRequest,
} from '@proto/store/api/store/category';

import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoryRepositoryService {
  constructor(private http: LativHttpClient) {}

  getCategory(req: GetCategoryRequest): Observable<Category> {
    return this.http
      .get('v1/categories', { params: GetCategoryRequest.toJSON(req) as { [param: string]: string } })
      .pipe(map(res => Category.fromJSON(res)));
  }

  getCategoryContent(req: GetCategoryContentRequest): Observable<CategoryContent> {
    return this.http
      .get(
        `v1/categories/${encodeURIComponent(req.bigCategoryEn)}/${encodeURIComponent(req.mediumCategoryEn)}/content`,
        {
          params: GetCategoryContentRequest.toJSON(req) as {
            [param: string]: string;
          },
        }
      )
      .pipe(map(res => CategoryContent.fromJSON(res)));
  }
}
